/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MarketShoppingCartIcon16Light } from './MarketShoppingCartIcon16Light';
import { MarketShoppingCartIcon16Regular } from './MarketShoppingCartIcon16Regular';
import { MarketShoppingCartIcon16Solid } from './MarketShoppingCartIcon16Solid';
import { MarketShoppingCartIcon20Light } from './MarketShoppingCartIcon20Light';
import { MarketShoppingCartIcon20Regular } from './MarketShoppingCartIcon20Regular';
import { MarketShoppingCartIcon20Solid } from './MarketShoppingCartIcon20Solid';
import { MarketShoppingCartIcon24Regular } from './MarketShoppingCartIcon24Regular';
import { MarketShoppingCartIcon24Solid } from './MarketShoppingCartIcon24Solid';
import { MarketShoppingCartIcon32Regular } from './MarketShoppingCartIcon32Regular';
import { MarketShoppingCartIcon64Regular } from './MarketShoppingCartIcon64Regular';
var sizes = {
    16: {
        light: MarketShoppingCartIcon16Light,
        regular: MarketShoppingCartIcon16Regular,
        solid: MarketShoppingCartIcon16Solid,
    },
    20: {
        light: MarketShoppingCartIcon20Light,
        regular: MarketShoppingCartIcon20Regular,
        solid: MarketShoppingCartIcon20Solid,
    },
    24: {
        regular: MarketShoppingCartIcon24Regular,
        solid: MarketShoppingCartIcon24Solid,
    },
    32: {
        regular: MarketShoppingCartIcon32Regular,
    },
    64: {
        regular: MarketShoppingCartIcon64Regular,
    },
};
export var MarketShoppingCartIcon = forwardRef('MarketShoppingCartIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
